import type { MutationKey, QueryKey } from "@tanstack/react-query"

function EAttendanceMarksQueryKey(params: { sessionId: number }): QueryKey {
    return ["Attendances", `sessionId:${params.sessionId}`]
}

function EAttendanceMarksQueryUrl(params: { sessionId: number }): string {
    return `/api/coach-session/${params.sessionId}/assign-modules-mark-attendance-detail/`
}

function EAttendanceMarksMutationKey(params: { sessionId: number }): MutationKey {
    return ["Attendances", `sessionId:${params.sessionId}`]
}

function EAttendanceMarksMutationUrl(params: { sessionId: number }): string {
    return `/api/coach-session/${params.sessionId}/assign-modules-mark-attendance/`
}

export { EAttendanceMarksQueryKey, EAttendanceMarksQueryUrl, EAttendanceMarksMutationKey, EAttendanceMarksMutationUrl }
